import { setShowForm } from "./showFormSlice";

export const changeShowForm = (showForm) => {
  return async (dispatch) => {
    dispatch(setShowForm(showForm));
  };
};
